import Model from '@/models/Model'

export default class SlCustomer extends Model {
    resource() {
        return 'sl_customer'
    }
}